export const COUNT_CONTRACT_ADDRESS = '0x03fe8788D7E5cd22e423b6f8500DA5e8C5F2AC0d';
export const NFT_CONTRACT_ADDRESS = '0x087459a4733C689616ff31515FA9B555493954e2';
export const MARKET_CONTRACT_ADDRESS = '0x0976ebBA60D5bf88F8FaeEd8c7553c6b917De9e5';

export const ACCESS_KEY_ID = 'KASK2M2WMIAK8IUBDY4195H6';
export const SECRET_ACCESS_KEY = 'JpV3d6F6k087ji3s2rL9SoZ7Z3opIYgCgxDgALor';
export const CHAIN_ID = '8217'; //MAINNET 8217 , TESTNET 1001